import {useBlockProps, 
    useInnerBlocksProps,
    BlockControls,
    JustifyContentControl,
} from '@wordpress/block-editor'
import  "./editor.scss";
import {farseValue} from "../../utills/parseValue";
export default function Edit(props){
    let blockGap = props.attributes?.style?.spacing?.blockGap;
        blockGap = blockGap ? farseValue(blockGap) : null;

    const blockProps = useBlockProps({
        style: { gap:blockGap, justifyContent:props.attributes.JustifyContent }
    });
    const innerBlocksProps = useInnerBlocksProps(blockProps,{
        template: [["fse-blocks/post-button",{}]],
        allowedBlocks: ["fse-blocks/post-button"]
    });
    return (
    <>
    <BlockControls>
        <JustifyContentControl 
        value={props.attributes.JustifyContent}
        onChange={(value)=>{props.setAttributes({JustifyContent:value})}}
        />
    </BlockControls>
    <div {...innerBlocksProps} />
    </>
)
}